import { compareOutputValues } from "@src/core/engine/helpers/compareOutputValues";
import { BatchSelectionRow } from "@src/routes/projects/$projectId/selections/batch/$category/store/types";
import { TechnicalSelectionOutput } from "@src/routes/projects/$projectId/selections/hooks/useBuildSuggestionOutput";
import { Row, TableFeatures } from "@tanstack/react-table";

export function getBatchOutputSortFn(
  rowA: Row<TableFeatures, BatchSelectionRow>,
  rowB: Row<TableFeatures, BatchSelectionRow>,
  columnId: string,
) {
  const isOutput = columnId.includes("output");
  const isPipe = columnId.includes("pipeResult");
  if (isOutput || isPipe) {
    const { values: valueA } =
      rowA.getValue<TechnicalSelectionOutput>(columnId);
    const { values: valueB } =
      rowB.getValue<TechnicalSelectionOutput>(columnId);
    return compareOutputValues(valueA, valueB);
  }

  const valueA = rowA.getValue<string>(columnId);
  const valueB = rowB.getValue<string>(columnId);
  return valueA.localeCompare(valueB);
}
